// extracted by mini-css-extract-plugin
export default {"table":"paginatedTable_table__JMtdG"};